<div class="close-container">
  <img src="../../../assets/close_icon.svg" (click)="onClose()" class="close" role="button" tabindex="0" aria-label="Close" alt="Close" (keydown.enter)="onClose()" (keydown.space)="$event.preventDefault(); onClose()" />
</div>
<div class="component" *ngIf="!isAcura">
  <p class="font-16 font-weight-400 black-color text-center-align">
    Please download the HondaLink Mobile App to add additional drivers in the
    Vehicle Profile screen.
  </p>
  <div class="download-icon-container">
    <a target="_blank" rel="noopener noreferrer" href="{{isAcura ? 'https://apps.apple.com/us/app/acuralink/id610964308?mt=8' : 'https://apps.apple.com/us/app/hondalink-connect/id750465030?mt=8'}}">
      <img class="" src="../../../../assets/icons/apple-store-badge.png" alt="Download on the App Store" />
    </a>
    <a target="_blank" rel="noopener noreferrer"
      href="{{isAcura ? 'https://play.google.com/store/apps/details?id=com.acura.acuralink.connect' : 'https://play.google.com/store/apps/details?id=com.honda.hondalink.connect'}}">
      <img class="" src="../../../../assets/icons/google-play-badge.png" alt="Get it on Google Play" />
    </a>
  </div>
  <div class="action-btn-container flex justify-content-center">
    <button mat-flat-button class="edit-form-button standard-btn primar-btn btn-width" (click)="onClose()">
      Close
    </button>
  </div>
</div>
<div class="component" *ngIf="isAcura">
  <p class="font-16 font-weight-400 black-color text-center-align">
    Please download the AcuraLink Mobile App to add additional drivers in the
    Vehicle Profile screen.
  </p>
  <div class="download-icon-container">
    <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/us/app/acuralink/id610964308?mt=8">
      <img class="" src="../../../../assets/icons/apple-store-badge.png" alt="Download on the App Store" />
    </a>
    <a target="_blank" rel="noopener noreferrer"
      href="https://play.google.com/store/apps/details?id=com.acura.acuralink.connect">
      <img class="" src="../../../../assets/icons/google-play-badge.png" alt="Get it on Google Play" />
    </a>
  </div>
  <div class="action-btn-container flex justify-content-center">
    <button mat-flat-button class="edit-form-button standard-btn primar-btn btn-width" (click)="onClose()">
      Close
    </button>
  </div>
</div>
